var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, useContext, useState, useEffect } from '@max/max';
import Text from '@max/leez-text';
import View from '@hfe/max-view';
import { Countdown } from '@nibfe/marketing-blocks-universal';
import { getMultiLimitTimeText } from '../../utils/coupon';
import { CouponStatus } from '@nibfe/mkt-coupon-api';
import { hasValidStateStatusList } from '../../lib/constant';
import './index.scss';
export default function ExpiredTime(props) {
    const { _runtimeInfo, _raptorReport } = useContext(global._EngineGlobalContext);
    let { pageId } = _runtimeInfo || {};
    pageId = String(pageId);
    const { containerStyle = {}, currentTimeMillis, couponData, className, updateCouponList } = props;
    const { status, beginTime, endTime, isValid } = couponData || {};
    const [text, setText] = useState('');
    const [isShowCountdown, setIsShowCountdown] = useState('');
    const isCouponNotStart = status === CouponStatus.NotStart;
    const isNotValid = hasValidStateStatusList.includes(status) && !isValid;
    const afterCountDownText = isCouponNotStart ? '可领' : isNotValid ? '后可用' : '后到期';
    useEffect(() => {
        const text = getMultiLimitTimeText(Number(isCouponNotStart || isNotValid ? beginTime : endTime), Number(currentTimeMillis), status, isValid);
        setText(text);
        setIsShowCountdown(typeof text === 'number');
    }, [isCouponNotStart, beginTime, endTime, currentTimeMillis, status, isNotValid, isValid]);
    const countEnd = () => __awaiter(this, void 0, void 0, function* () {
        try {
            setIsShowCountdown(false);
            setText('');
            updateCouponList();
        }
        catch (e) {
            _raptorReport === null || _raptorReport === void 0 ? void 0 : _raptorReport.reportLog('神券预发券报错-倒计时', e, {
                level: 'warn'
            });
        }
    });
    const inlineStyle = {
        coundDownStyle: {
            color: '#FF4B10',
            fontSize: '20rpx',
            lineHeight: '24rpx'
        },
        textStyle: {
            fontSize: '20rpx',
            lineHeight: '24rpx',
            marginLeft: isShowCountdown ? '4rpx' : 0,
            height: '24rpx'
        }
    };
    const containerClassName = `magicmember-expired-time ${className}`;
    return <View className={containerClassName} style={containerStyle}>
      <Countdown x-if={isShowCountdown} startTimestamp={Number(currentTimeMillis)} endTimestamp={Number(isCouponNotStart || isNotValid ? beginTime : endTime)} textWordSpace={0} isShowDays={false} isShowSecs={true} timeConnectSymbol="colon" onCountEnd={countEnd} timeStyle={inlineStyle.coundDownStyle} connectStyle={inlineStyle.coundDownStyle}></Countdown>
      <Text style={inlineStyle.textStyle} text={isShowCountdown ? afterCountDownText : text} type="label2" color="#999" lineClamp={1}/>
    </View>;
}
